import React from 'react';
import ReactDOM from 'react-dom/client';
import './modern.css';
import './app-improvements.css';
import './styles/globals.css';
import './styles/mobile.css';
import App from './App';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


